import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useAppSelector } from '../../../../../hooks/redux'
import { Colors } from '../../../../../constants/Colors'
import style from './NavBarItem.module.css'

const render = {
    '/panel': 0,
    '/admins': 0,
    '/profiles': 0,
    '/stores': 0,
    '/products': 0,
    '/advertisings': 0,
    '/banners': 0,
    '/logout': 0,
    '/': 0,
    '/terms-of-use': 0,
    '/privacy': 0,
    '/copyright': 0,
}

interface Props {
    to: string,
    icon: string,
    title: string,
    count: number | null
}

const NavBarItem = ({to, icon, title, count}: Props) => {

    //console.warn(` NavbarItem${to} render: ${++render[`${to}`] }`)

    const theme = useAppSelector<string>(state => state.theme.theme)

    const [isHover, setIsHover] = useState<boolean>(false)

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <NavLink
            to={to}
            className={
                ({isActive}) => isActive
                    ? style.navItem + " " + style.active
                    : style.navItem
            }
            style={
                ({isActive}) => isActive
                ? {
                    color: Colors[theme].activeTint,
                    backgroundColor: Colors[theme].app
                }
                : isHover
                    ? {
                        fontSize: '1.5em',
                        color: Colors[theme].app,
                        backgroundColor: Colors[theme].inActiveTint
                    }
                    : {color: Colors[theme].text}
            }
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <span
                className={style.icon}
            >
                <i className={icon}></i>
            </span>
            <span
                className={style.title}
            >
                {title}
            </span>
            <span
                className={style.count}
            >
                {count}
            </span>
        </NavLink>
    )
}

export default NavBarItem
